<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableBackupPlan",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanId"),
          key: "backupPlanId"
        },

        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanName"),
          key: "backupPlanName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path:
                        "/resourceConfigurationManagement/aws/backup/serverlessReplications/backupPlanName",
                      query: {
                        backupPlanName: params.row.backupPlanName,
                        id: params.row.id,
                        type: "backupPlanName",
                        t: Date.now()
                      }
                    });
                  }
                }
              },
              params.row.backupPlanName
            );
          }
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.lastExecutionDate"),
          key: "lastExecutionDate"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.creationDate"),
          key: "creationDate"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("backupPlanName", function(val) {
      tableDataVue.backupPlanName = val;
    });
    eventBus.$on("backupPlanId", function(val) {
      tableDataVue.backupPlanId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAwsBackupPlanByPage({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          backupPlanName: tableDataVue.backupPlanName,
          backupPlanId: tableDataVue.backupPlanId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/plan/TableBackupPlan.vue